import {Injectable} from '@angular/core';
import {UmpireStandings} from '@tisa-group/models';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
} from '@tisa-group/cdk';

@Injectable()
export class StandingsService implements CrudService {
  constructor(readonly http: TisaUmpireHttpService) {}

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireStandings>> {
    return this.http
      .get(`/groups/${fetchIdentifier}/standings`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
